import './chatbubble.css';
import { ReactComponent as KitoAsking } from '../../assets/designSystem/icons/firstAid/KitoAsking.svg';
import KitoBuddy2 from '../../assets/kitoBuddy/Celebration.png';

export default function ChatBubble({ text, text2, text3, finish }) {
  return (
    <div className="bubble__container">
      {finish ? <img src={KitoBuddy2} alt="buddy" className="kito__buddy" /> : <KitoAsking className="kito__image" />}
      <div className="bubble">
        <svg viewBox="0 0 194 42" preserveAspectRatio="none" className="bubble__svg">
          <path
            d="M189.19 40.6001H11.6009C9.71921 40.6001 8.19091 39.2786 8.19091 37.6515V35.0333C8.19091 33.3154 6.56708 31.936 4.58029 31.9608L2.22096 31.9939C0.864592 32.0104 0.100441 30.6476 0.969665 29.7391L6.20411 24.2631C7.49362 22.9168 8.19091 21.2319 8.19091 19.481V3.54869C8.19091 1.9216 9.71921 0.600098 11.6009 0.600098H189.19C191.072 0.600098 192.6 1.9216 192.6 3.54869V37.635C192.6 39.2621 191.072 40.5836 189.19 40.5836V40.6001Z"
            stroke="#058794"
            strokeWidth="1.2"
            fill="white"
          />
        </svg>

        <p className={finish ? 'bubble__text1' : 'bubble__text'}>{text}</p>
        <p className="bubble__text bubble__text2">{text2}</p>
        {text3 && (
          <p className="bubble__text1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clipPath="url(#clip0_2220_114967)">
                <path
                  d="M7.34496 1.87629C7.37353 1.72336 7.45468 1.58524 7.57436 1.48584C7.69404 1.38644 7.84472 1.33203 8.00029 1.33203C8.15587 1.33203 8.30655 1.38644 8.42623 1.48584C8.54591 1.58524 8.62706 1.72336 8.65563 1.87629L9.35629 5.58163C9.40606 5.84506 9.53408 6.08737 9.72365 6.27694C9.91322 6.46651 10.1555 6.59453 10.419 6.64429L14.1243 7.34496C14.2772 7.37353 14.4153 7.45468 14.5147 7.57436C14.6141 7.69404 14.6686 7.84472 14.6686 8.00029C14.6686 8.15587 14.6141 8.30655 14.5147 8.42623C14.4153 8.54591 14.2772 8.62706 14.1243 8.65563L10.419 9.35629C10.1555 9.40606 9.91322 9.53408 9.72365 9.72365C9.53408 9.91322 9.40606 10.1555 9.35629 10.419L8.65563 14.1243C8.62706 14.2772 8.54591 14.4153 8.42623 14.5147C8.30655 14.6141 8.15587 14.6686 8.00029 14.6686C7.84472 14.6686 7.69404 14.6141 7.57436 14.5147C7.45468 14.4153 7.37353 14.2772 7.34496 14.1243L6.64429 10.419C6.59453 10.1555 6.46651 9.91322 6.27694 9.72365C6.08737 9.53408 5.84506 9.40606 5.58163 9.35629L1.87629 8.65563C1.72336 8.62706 1.58524 8.54591 1.48584 8.42623C1.38644 8.30655 1.33203 8.15587 1.33203 8.00029C1.33203 7.84472 1.38644 7.69404 1.48584 7.57436C1.58524 7.45468 1.72336 7.37353 1.87629 7.34496L5.58163 6.64429C5.84506 6.59453 6.08737 6.46651 6.27694 6.27694C6.46651 6.08737 6.59453 5.84506 6.64429 5.58163L7.34496 1.87629Z"
                  stroke="#004853"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.333 1.33203V3.9987"
                  stroke="#004853"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.6667 2.66797H12"
                  stroke="#004853"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.66634 14.6667C3.40272 14.6667 3.99967 14.0697 3.99967 13.3333C3.99967 12.597 3.40272 12 2.66634 12C1.92996 12 1.33301 12.597 1.33301 13.3333C1.33301 14.0697 1.92996 14.6667 2.66634 14.6667Z"
                  stroke="#004853"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_2220_114967">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            {text3}
          </p>
        )}
      </div>
    </div>
  );
}
